// extracted by mini-css-extract-plugin
module.exports = {"homeCardContainer":"_1aWal","cardContentLeft":"_3LKYL","cardContentRight":"_32OmI"};